/**
 * Created by shubham on 24/4/18.
 * Update by neha on 03/02/26
 */

import { Component } from '@angular/core';
import { APPCONFIG } from '../../config';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpService } from '../../shared/services/http.service'
import { MdDialog,MdDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { DialogComponent } from '../../dialog/dialog.component';
import {SessionHandler} from "../../shared/services/session-handler.service";

@Component({
    template: require('./add-edit-user.component.html')
})

export class AddEditUserComponent {
    data: any = [];
    dialogRef;
    userDetails:any;
    UserForm: FormGroup;
    UserFormDetails: any;
    id: any;
    emailPattern = APPCONFIG.emailPattern;
    //passwordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
    // passwordPattern = /^(?=.*?[A-Za-z])(?=.*?[0-9]).{5,}$/;
    passwordPattern = /^(?=[A-Za-z])(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[~@$%^&*_\-+‘|=(){}\[\]:;‘"\\<>,.\/])[A-Za-z0-9~@$%^&*_\-+‘|=(){}\[\]:;‘"\\<>,.\/]{16,40}$/;
    settings = {};
    LanguageDetails = [];
    passwordErrorMsg: string = '';

    constructor(private router: Router, public sessionHandler: SessionHandler, private route: ActivatedRoute, private httpService: HttpService, private formBuilder: FormBuilder, private dialog: MdDialog) {
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        this.getLanguages();
    }

    public getLanguages(){
        this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(
            res => { this.saveLanguageResponse(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    validateName(event: any) {
        return APPCONFIG.validNameRegex.test(event.key);
    }
    public saveLanguageResponse(res) {
        if(res){
            if(res.items){
                this.LanguageDetails = res.items;
            }
        }
        this.httpService.onEnd();
    }

    buildForm() {
        this.UserForm = this.formBuilder.group({
            firstName: this.formBuilder.control(null, [Validators.required]),
            lastName: this.formBuilder.control(null, [Validators.required]),
            password: this.formBuilder.control('', [Validators.required,Validators.minLength(16),Validators.maxLength(40),Validators.pattern(this.passwordPattern),this.noPersonalInfoValidator.bind(this)]),
            confirmPassword: this.formBuilder.control('', [Validators.required]),
            email: this.formBuilder.control(null, [Validators.required, Validators.pattern(this.emailPattern)]),
            languageId: this.formBuilder.control(null, [Validators.required]),
        },  {validator: this.checkPasswords});
        this.UserForm.valueChanges.subscribe(data => {
            this.UserFormDetails = this.UserForm.getRawValue();
            this.UserFormDetails.validate = this.UserForm.valid;
        });

        this.UserForm.get('password').valueChanges.subscribe(data => {
        if (!data) return;

        if (data.length < 16 || data.length > 40) {
            this.passwordErrorMsg = "Minimum of 16 characters and maximum of 40 characters long";
        } else if (!/^[A-Za-z]/.test(data)) {
            this.passwordErrorMsg = "First character must be an alphabet";
        } else if (!/[A-Z]/.test(data)) {
            this.passwordErrorMsg = "Contain at least one uppercase character (A–Z)";
        } else if (!/[a-z]/.test(data)) {
            this.passwordErrorMsg = "Contain at least one lowercase character (a–z)";
        } else if (!/[0-9]/.test(data)) {
            this.passwordErrorMsg = "Contain at least one numeric character (0–9)";
        } else if (!/[~@$%^&*_\-+‘|=(){}\[\]:;‘"\\<>,.\/]/.test(data)) {
            this.passwordErrorMsg =   'Contain at least one special character (~ @ $ % ^ & * _ - + | = ( ) { } [ ] : ; " \\ < > , . /)';
        } else if (this.UserForm.get('password').hasError('personalInfo')) {
            this.passwordErrorMsg = "Should not contain your first name, last name, or user id";
        } else {
            this.passwordErrorMsg = "";
        }
    });

    }

    noPersonalInfoValidator(control: any) {
        if (!control || !control.value || !this.UserForm) return null;
        var password = control.value.toLowerCase();
        var firstNameCtrl = this.UserForm.get('firstName');
        var lastNameCtrl = this.UserForm.get('lastName');
        var emailCtrl = this.UserForm.get('email');
        var firstName = firstNameCtrl && firstNameCtrl.value
            ? firstNameCtrl.value.toLowerCase()
            : '';
        var lastName = lastNameCtrl && lastNameCtrl.value
            ? lastNameCtrl.value.toLowerCase()
            : '';
        var email = emailCtrl && emailCtrl.value
            ? emailCtrl.value.toLowerCase()
            : '';
        var emailUser = email.indexOf('@') > -1 ? email.split('@')[0] : '';
        if (
            (firstName && password.indexOf(firstName) > -1) ||
            (lastName && password.indexOf(lastName) > -1) ||
            (emailUser && password.indexOf(emailUser) > -1)
        ) {
            return { personalInfo: true };
        }
        return null;
    }
    showPassword(input: any): any {
        input.type = input.type === 'password' ?  'text' : 'password';
    }

    checkPasswords(group: FormGroup) {
        if(group.get('password').value === group.get('confirmPassword').value){
            group.get('confirmPassword').setErrors(null);
            return null;
        } else{
            group.get('confirmPassword').setErrors({'incorrect': true});
            return {'mismatch': true};
        }
    }

    public saveUserData(){
        this.httpService.postRequest(this.UserFormDetails,'partnerOperationsApi/v1/createCompanyUser').subscribe(
            res => { this.saveResponse(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveResponse(res){
        if(res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'user_creation_failed';
        } else {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = "registration_rqst_notify";
            //this.dialogRef.componentInstance.msg = "User Created Successfully";
            this.dialogRef.afterClosed().subscribe(result => {
                this.router.navigateByUrl('/app/partners-dashboard');
            });
        }
    }

    ngOnInit(): void {
        this.buildForm();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user/add-edit-user/add-edit-user.component.ts